import { IConfig } from "Config";
var config: IConfig = {
    // BASE_API_URL: 'https://0123456789.ehoadon.net/',
    BASE_API_URL: 'https://localhost:44347/',
    BASE_URL: process.env.BASE_URL
};

export default config;